export default class StoryConventions {
    static nodeIdToVisitVariable(nodeId) {
        return `node_${nodeId}_visited`;
    }

    static isInternalStakeholderId(string, internalStakeholderIds) {
        return internalStakeholderIds.indexOf(string) > -1;
    }
}

StoryConventions.TEA_CORNER_TITLE = "tea-corner";
StoryConventions.DASHBOARD_TITLE = "dashboard";